/* @flow */
import Message from 'entities/Message';
import PropTypes from 'prop-types';
import * as React from 'react';
import cx from 'classnames';
import './styles/GroupMessageBase.scss';

class GroupMessageBase extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    message: PropTypes.instanceOf(Message).isRequired,
    border: PropTypes.bool,
    backgroundColor: PropTypes.string,
  };

  static childContextTypes = {
    message: PropTypes.instanceOf(Message).isRequired,
  };

  getChildContext() {
    return {
      message: this.props.message,
    };
  }

  render() {
    const style = {};
    if (this.props.backgroundColor) {
      Object.assign(style, {
        backgroundColor: this.props.backgroundColor,
      });
    }

    return (
      <div className={cx('GroupMessageBase', this.props.className)}>
        <div
          style={style}
          className={cx({
            'GroupMessageBase-card': true,
            'GroupMessageBase-bordered': this.props.border,
            'GroupMessageBase-failed': this.props.message.getStatus() === 'failed',
          })}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default GroupMessageBase;
